module.exports = __webpack_public_path__ + "static/Werebear-b9aeddb05e1a83a04690669d886e298b.jpg";